import {store} from "../index";
import {refreshArtistTokenSuccessAction, refreshStudioTokenSuccessAction} from "../store/auth/authActions";
import {selectArtistAuth, selectStudioAuth} from "../store/auth/authSelector";


export const registerRefreshedToken = (name, token) => {
    if (name === 'artistToken') {
        store.dispatch(refreshArtistTokenSuccessAction(token))
    } else if (name === 'studioToken') {
        store.dispatch(refreshStudioTokenSuccessAction(token))
    } else {
        throw new Error('Invalid token name ' + name)
    }
}

export const getTokens = () => {
    const state = store.getState()
    return {
        artistTokens: selectArtistAuth(state),
        studioTokens: selectStudioAuth(state)
    }
}

export const getArtistToken = () => {
    const state = store.getState()
    return selectArtistAuth(state)
}
